import { ExpertDashboard } from '@expert/routes/ExpertDashboard'

export default ExpertDashboard
